import {main, TypeFlightPlanning} from '../base-image';

import FlightPlanningMap from './components/Content';

import createReducer from './reducer';
import {confirmRegionChange} from './actionCreators';

const initialState = {
    animationStart: 8,
    animationStop: 16,
    OSMLayer: 'TOPO-WMS',
    OSMColored: false,
    OSMOpacity: 0.5,
    FAIEnabled: true,
};

const props = {Content: FlightPlanningMap, fluid: false};

main(TypeFlightPlanning, initialState, {props, createReducer, confirmRegionChange});
